import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { DSType, useTypesTableContext } from '../../../../TypesTableContext'
import { useEditDsTypeMutation } from 'schema'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { EditFormItemsValues } from '../../components/CreateEditFormItems/types'

export function useEdit(): EditRowActionOptions<DSType, EditFormItemsValues> {
  const { refetch } = useTypesTableContext()
  const [edit] = useEditDsTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editDSType: {
        type: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditDesignSubmittalType,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, description }) => {
        return { name, description }
      },
      onOk: async (
        { id, name: prevName, description: prevDescription },
        { name, description }
      ) => {
        if (prevName !== name || prevDescription !== description) {
          await edit({
            variables: { editDsTypeInput: { id, name, description } },
          })
          refetch()
        }
      },
    },
  }
}
